import { memo, ReactNode } from 'react'
import { Route } from 'react-router-dom'

import InfoMessage from 'components/ui/InfoMessage'
import { useTranslation } from 'hooks'

const ErrorView = ({ title, text }: { title?: string; text?: ReactNode }): JSX.Element => {
  const { t } = useTranslation()
  return (
    <Route>
      <div>
        <InfoMessage title={title ?? t('auth.notAllowed')} text={text} nature='error' />
      </div>
    </Route>
  )
}

export default memo(ErrorView)
